var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCRUDPageLayout',{attrs:{"links":_vm.links},scopedSlots:_vm._u([{key:"tableName",fn:function(){return [_vm._v(" مستخدمي المنصة ")]},proxy:true},{key:"dataTable",fn:function(){return [_c('UsersTable')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }